import { useEffect, useState } from "react";

export const CatalogoTradicionalCheckBox = ({Each, offices, isCheckedOffice,
    isCheckedFather, setOficinasCheck, oficinasCheck, setFirstFilter
}) => { // Each es zona

    const [checkDaddy, setCheckDaddy] = useState(false)

    useEffect(() => {
        setCheckDaddy(isCheckedFather(Each))
    }, [])

    useEffect(() => {
        setCheckDaddy(isCheckedFather(Each))
    }, [oficinasCheck])

    return (
        <li>
													<div className="checkbox_flex">
													<input
														type='checkbox'
														
														id={Each.replace(" ", "")}

														// onChange={() => handleCheckboxChange(Each)}
                                                        onClick={(e) => {
                                                            if(e.target.checked){
                                                                
                                                                setCheckDaddy(true)
                                                                if(Each !== "Nacional"){
                                                                // Filtrar las oficinas en 'offices' que no tengan 'group' igual a 'Each'
                                                                const oficinasFiltradas = offices.filter(element => element.group === Each);

                                                                // Concatenar las oficinas filtradas con las existentes en 'oficinasCheck'
                                                                const nuevasOficinasCheck = oficinasCheck.concat(oficinasFiltradas);

                                                                // Eliminar duplicados en 'nuevasOficinasCheck' si es necesario
                                                                const oficinasCheckSinDuplicados = Array.from(new Set(nuevasOficinasCheck));

                                                                // Actualizar el estado 'oficinasCheck' con las oficinas filtradas y sin duplicados
                                                                setOficinasCheck(oficinasCheckSinDuplicados);
                                                                }else{
                                                                    setOficinasCheck(offices)
                                                                }

                                                            }else{
                                                                // alert("NO ESTÁ CHECKEADO")
                                                                if(Each !== "Nacional"){
                                                                    setOficinasCheck(
                                                                        oficinasCheck.filter(
                                                                            (of) => of.group !== Each
                                                                        )
                                                                    )
                                                                }else{
                                                                    setOficinasCheck([])
                                                                }
                                                                setCheckDaddy(false)
                                                            }
                                                        }}
														checked={checkDaddy}
														// defaultChecked={isCheckedFather(Each)}
														
													/>
													<label
														htmlFor={Each.replace(" ", "")}
														
													></label>
													<p>{Each}</p>
													</div>

						{(Each != "Nacional") && offices
						.filter(function (element) {
							return element.group == Each
						})
						.map((EachArr) => (
													<>
														<div className="checkbox_flex checkbox_flex_inner">
														<input
														type='checkbox'
														name='oficinas[]'
														id={EachArr.office_name.replace(" ","")}
														onChange={(e) => {
															if (e.target.checked) {
																setOficinasCheck([
																	...oficinasCheck,
																	{
																		id: EachArr.id,
																		office_name: EachArr.office_name,
																		group: EachArr.group,
																	},
																])
																
																console.log('Agregando')
																console.log(oficinasCheck)
															} else {
																// remove from list
																setOficinasCheck(
																	oficinasCheck.filter(
																		(of) => of.id !== EachArr.id
																	)
																)
																setFirstFilter(
																	'Seleccione Oficina(s) Total: ' +
																		String(oficinasCheck.length - 1)
																)
																console.log('Quitando')
																console.log(oficinasCheck)
															}
                                                            setCheckDaddy(isCheckedFather(Each))
															// document.getElementById(Each.replace(" ","")).checked = isCheckedFather(Each);
														}}
                                                        checked={isCheckedOffice(EachArr.id)}
														defaultChecked={isCheckedOffice(EachArr.id)}
													/>
													<label
														htmlFor={`${EachArr.office_name.replace(" ","")}`}
														onClick={(e) => {
															setFirstFilter(EachArr.office_name)
														}}
													></label>
													<p>{EachArr.office_name}</p>
														</div>
													</>
													))}
												</li>
    );
};